import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router";
import LoginPage from "../Components/Login";
import AdminRoutes from "./AdminRoutes";
import ProtectedRoute from "./ProtectedRoute";



const AppRouter = () => {

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />

      <Route element={<ProtectedRoute />}>
        {AdminRoutes()}
      </Route>

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRouter;
